import ContactService from "../services/contactsService";
import * as ActionTypes from "../actions/actionTypes";

const contactsLoading = () => ({
  type: ActionTypes.CONTACTS_LOADING,
  payload: {},
});

const contactsLoaded = contacts => ({
  type: ActionTypes.CONTACTS_LOADED,
  payload: {
    contacts: contacts,
  },
});

export function loadContacts() {
  return (dispatch, getstate) => {
    var securityToken = getstate().user.securityToken;

    dispatch(contactsLoading());

    ContactService.loadContacts(
      getstate().config.server,
      securityToken,
      dispatch
    )
      .then(contacts => {
        dispatch(contactsLoaded(contacts));
      })
      .catch(function(error) {});
  };
}

export function deleteContact(id) {
  return (dispatch, getstate) => {
    var securityToken = getstate().user.securityToken;

    dispatch(contactsLoading());

    ContactService.delete(id, getstate().config.server, securityToken, dispatch)
      .then(() => {
        dispatch(deleteContactLocally(id));
      })
      .catch(function(error) {
        dispatch(serverError());
      });
  };
}

export function saveContact(values) {
  return (dispatch, getstate) => {
    var data = { ...values };
    delete data["name"];

    var securityToken = getstate().user.securityToken;

    dispatch(contactsLoading());

    if (values.id) {
      ContactService.update(
        data,
        getstate().config.server,
        securityToken,
        dispatch
      )
        .then(() => {
          dispatch(updateContactLocally(values));
        })
        .fail((xhr, ajaxOptions, thrownError) => {
          dispatch(serverError());
        });
    } else {
      ContactService.add(
        data,
        getstate().config.server,
        securityToken,
        dispatch
      )
        .then(() => {
          dispatch(loadContacts());
        })
        .catch(function(error) {
          dispatch(serverError());
        });
    }
  };
}

export const updateContactLocally = data => ({
  type: ActionTypes.UPDATE_CONTACT_LOCALLY,
  payload: {
    data: data,
  },
});

export const deleteContactLocally = id => ({
  type: ActionTypes.DELETE_CONTACT_LOCALLY,
  payload: {
    id: id,
  },
});

export const serverError = () => ({
  type: ActionTypes.CONTACT_REMOVE_LOADING,
});

export const noSipGiven = () => ({
  type: ActionTypes.CONTACT_NO_SIP_GIVEN,
});

export const clearContactAlert = () => ({
  type: ActionTypes.CONTACT_CLEAR_ALERT,
});






// WEBPACK FOOTER //
// ./src/actions/contactActions.js